import {css} from '@emotion/core'

const fadeInOutAndHide = {
  exiting: css`
    opacity: 0;
    display: block;
    transition: opacity 300ms ease-in;
  `,
  exited: css`
    opacity: 0;
    display: none;
    transition: opacity 300ms ease-in;
  `,
  entering: css`
    opacity: 0;
    display: block;
    transition: opacity 300ms ease-in;
  `,
  entered: css`
    opacity: 1;
    display: block;
    transition: opacity 300ms ease-in;
  `
}

const slideRight = time => ({
  exiting: css`
    transform: translate(100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  exited: css`
    transform: translate(100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entering: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entered: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `
})

const slideLeft = time => ({
  exiting: css`
    transform: translate(-100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  exited: css`
    transform: translate(-100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entering: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entered: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `
})

const slideUp = time => ({
  exiting: css`
    transform: translate(0, -100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  exited: css`
    transform: translate(0, -100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entering: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entered: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `
})

const slideDown = time => ({
  exiting: css`
    transform: translate(0, 100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  exited: css`
    transform: translate(0, 100%);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entering: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `,
  entered: css`
    transform: translate(0);
    transition: transform ${time}ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  `
})

const overlayFade = time => ({
  exiting: css`
    opacity: 0;
    will-change: opacity;
    transition: opacity ${time / 1.5}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `,
  exited: css`
    opacity: 0;
    will-change: opacity;
    transition: opacity ${time / 1.5}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `,
  entering: css`
    opacity: 1;
    will-change: opacity;
    transition: opacity ${time / 1.5}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `,
  entered: css`
    opacity: 1;
    will-change: opacity;
    transition: opacity ${time}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `
})

export default {
  fadeInOutAndHide,
  overlayFade,
  slideRight,
  slideLeft,
  slideUp,
  slideDown
}
